import { render, staticRenderFns } from "./sh_MagicLink.vue?vue&type=template&id=45d07335&scoped=true&"
import script from "./sh_MagicLink.vue?vue&type=script&lang=js&"
export * from "./sh_MagicLink.vue?vue&type=script&lang=js&"
import style0 from "./sh_MagicLink.vue?vue&type=style&index=0&id=45d07335&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d07335",
  null
  
)

export default component.exports